export default function Camera2({ style }) {
  return (
    <svg
      className={style}
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.25992 22H17.7399C20.4999 22 21.5999 20.31 21.7299 18.25L22.2499 9.99C22.3899 7.83 20.6699 6 18.4999 6C17.8899 6 17.3299 5.65 17.0499 5.11L16.3299 3.66C15.8699 2.75 14.6699 2 13.6499 2H11.3599C10.3299 2 9.12992 2.75 8.66992 3.66L7.94992 5.11C7.66992 5.65 7.10992 6 6.49992 6C4.32992 6 2.60992 7.83 2.74992 9.99L3.26992 18.25C3.38992 20.31 4.49992 22 7.25992 22Z'
        stroke='#8FC045'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11 8H14'
        stroke='#8FC045'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5 18C14.29 18 15.75 16.54 15.75 14.75C15.75 12.96 14.29 11.5 12.5 11.5C10.71 11.5 9.25 12.96 9.25 14.75C9.25 16.54 10.71 18 12.5 18Z'
        stroke='#8FC045'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
